import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { Geolocation } from '@ionic-native/geolocation';
import { LocalNotifications } from '@ionic-native/local-notifications';

import { Tools } from '../tools/tools';
import { User } from '../user/user';
import { SyncIO } from '../sync/sync';

declare var window: any;
declare var document: any;

@Injectable()
export class Tracking {
  status:boolean=false;
  watchback:any;
  watch:any;
  pedido:any;
  entrega:any;
  lastPosition:any;

  pedidoId:any;
  entregaId:any;
  motoristaId:any;

  constructor(
    public sync: SyncIO,
    public user: User,
    public tools: Tools,
    public geolocation: Geolocation,
    private localNotifications: LocalNotifications,
    public platform: Platform
  ) {
    this.init();
  }

  init(){
    this.platform.ready().then(()=>{
      window.BackgroundGeolocation.configure({
        locationProvider: window.BackgroundGeolocation.ACTIVITY_PROVIDER,
        desiredAccuracy: window.BackgroundGeolocation.HIGH_ACCURACY,
        notificationTitle: 'Tracking Barbosa',
        notificationText: 'Localizando GPS',
        startForeground: true,
        debug: false,
        stopOnTerminate: false,
        stopOnStillActivity: false,
        interval: 6000,
        fastestInterval: 5000,
        activitiesInterval: 2000
      });

      let self = this;
      window.BackgroundGeolocation.on('location',(location) => {
        let obj = {
          pedidoId:self.pedidoId+'',
          entregaId:self.entregaId+'',
          motoristaId:self.motoristaId+'',
          position:{
            lat:location.latitude,
            lng:location.longitude
          },
          time:new Date().getTime()
        }

        if(this.checkPosition(obj.position)){
          // this.tools.showAlert('toast','Nova posição: '+JSON.stringify(obj.position));
          console.log('Nova posição: '+JSON.stringify(obj.position));
          this.sync.send(obj,'updWork');
        }else{
          // this.tools.showAlert('toast','Mesma posição: '+JSON.stringify(obj.position));
          console.log('Mesma posição: '+JSON.stringify(obj.position));
        }
      });

      window.BackgroundGeolocation.on('stationary',(stationaryLocation) => {
        let obj = {
          pedidoId:self.pedidoId+'',
          entregaId:self.entregaId+'',
          motoristaId:self.motoristaId+'',
          position:{
            lat:stationaryLocation.latitude,
            lng:stationaryLocation.longitude
          },
          time:new Date().getTime()
        }

        if(this.checkPosition(obj.position)){
          // this.tools.showAlert('toast','Nova posição: '+JSON.stringify(obj.position));
          console.log('Nova posição: '+JSON.stringify(obj.position));
          this.sync.send(obj,'updWork');
        }else{
          // this.tools.showAlert('toast','Mesma posição: '+JSON.stringify(obj.position));
          console.log('Mesma posição: '+JSON.stringify(obj.position));
        }
      });

      window.BackgroundGeolocation.on('start',()=>{
        this.tools.showAlert('toast','startTracking');
      });
    });
  }

  start(pedido:any,entrega:any){
    this.pedidoId = pedido._id+'';
    this.entregaId = entrega._id+'';
    this.motoristaId = this.user.getUser()._id+'';
    window.BackgroundGeolocation.start();
  }

  stop(){
    window.BackgroundGeolocation.stop();
  }

  // getPosition(pedido:any,entrega:any){
  //   let self = this;
  //   self.geolocation.getCurrentPosition({timeout:5000,enableHighAccuracy:true}).then((resp) => {
  //     if(!resp.coords){console.log('Não existe');return}
  //     let obj = {
  //       pedidoId:pedido._id+'',
  //       entregaId:entrega._id+'',
  //       motoristaId:this.user.getUser()._id+'',
  //       position:{
  //         lat:resp.coords.latitude,
  //         lng:resp.coords.longitude
  //       },
  //       time:new Date().getTime()
  //     }
  //
  //     if(self.checkPosition(obj.position)){
  //       // self.tools.showAlert('toast','Nova posição: '+JSON.stringify(obj.position));
  //       self.sync.send(obj,'updWork');
  //     }else{
  //       // self.tools.showAlert('toast','Mesma posição: '+JSON.stringify(obj.position));
  //       console.log('Mesma posição: '+JSON.stringify(obj.position))
  //     }
  //   }).catch((error) => {
  //     console.log('Error getting location'+ error);
  //   });
  // }

  checkPosition(position){
    if(!this.lastPosition){
      this.lastPosition = position.lat+'#'+position.lng;
      return true;
    }
     let oldDistance = {lat:this.lastPosition.split('#')[0],lng:this.lastPosition.split('#')[1]};
     let distance = this.findDistance(oldDistance,position);
     if(distance*1000>3){
       this.lastPosition = position.lat+'#'+position.lng;
       return true;
     }else{
       return false;
     }
   }

   findDistance(posA,posB) {
     let rad;
     function deg2rad(deg) {
       rad = deg * Math.PI/180; // radians = degrees * pi/180
       return rad;
     }
     function round(x) {
       return Math.round( x * 1000) / 1000;
     }
     var Rm = 3961; // mean radius of the earth (miles) at 39 degrees from the equator
     var Rk = 6373; // mean radius of the earth (km) at 39 degrees from the equator
     var t1, n1, t2, n2, lat1, lon1, lat2, lon2, dlat, dlon, a, c, dm, dk, mi, km;

     // get values for lat1, lon1, lat2, and lon2
     t1 = posA.lat;
     n1 = posA.lng;
     t2 = posB.lat;
     n2 = posB.lng;

     // convert coordinates to radians
     lat1 = deg2rad(t1);
     lon1 = deg2rad(n1);
     lat2 = deg2rad(t2);
     lon2 = deg2rad(n2);

     // find the differences between the coordinates
     dlat = lat2 - lat1;
     dlon = lon2 - lon1;

     // here's the heavy lifting
     a  = Math.pow(Math.sin(dlat/2),2) + Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(dlon/2),2);
     c  = 2 * Math.atan2(Math.sqrt(a),Math.sqrt(1-a)); // great circle distance in radians
     dm = c * Rm; // great circle distance in miles
     dk = c * Rk; // great circle distance in km

     // round the results down to the nearest 1/1000
     mi = round(dm);
     km = round(dk);

     // display the result
     // frm.mi.value = mi;
     return km;
   }
}



// WEBPACK FOOTER //
// ./src/providers/tracking/tracking.ts